var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandingDownloadBg = function SvgBrandingDownloadBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 413,
    height: 304,
    viewBox: "0 0 413 304"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 413,
    height: 281,
    fill: "current",
    fillRule: "evenodd"
  })));
};
export default SvgBrandingDownloadBg;